
import React from 'react';
import { motion } from 'framer-motion';
// Generated at build time by scripts/generate-catalogue-stats.js. Importing
// coursesData/assessmentsData directly to count them pulled the whole catalogue
// into the landing-page bundle (+112 KB) for the sake of two integers.
import { CATALOGUE_STATS } from '@/data/catalogue-stats.js';

const TrustRow = () => {
  // Every figure here must be verifiable. This band previously carried
  // "50+ Enterprise Clients", "98% Success Rate" and "24/7 Expert Support" —
  // none of which we can substantiate, on the most-viewed page of the site.
  // Under Australian Consumer Law s.29 an unsubstantiated performance claim is
  // a misleading representation whether or not anyone relies on it.
  //
  // The two counts are DERIVED from the data rather than typed, so they cannot
  // drift out of true the next time a course or assessment is added — which is
  // how "20+ Certified Courses" ended up understating a catalogue of 61.
  const stats = [
    { value: `${CATALOGUE_STATS.courses}`, label: 'Courses' },
    { value: `${CATALOGUE_STATS.assessments}`, label: 'Free Assessments' },
    { value: 'Live', label: 'Instructor-Led' },
    { value: 'AU', label: 'Owned & Operated' }
  ];

  return (
    <section className="py-16 bg-[#280659] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid grid-cols-2 md:grid-cols-4 gap-8"
        >
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="text-center"
            >
              <div className="text-4xl md:text-5xl font-bold mb-2 bg-gradient-to-r from-[#F54952] to-[#AE2D68] bg-clip-text text-transparent">
                {stat.value}
              </div>
              <div className="text-gray-300">{stat.label}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TrustRow;
